import { useState } from "react";
import FormValidation from "../../../utils/FormValidation";
import { VideoInstruction } from "../../EventMgt/VideoInstruction";
import moment, { months } from "moment";
const Input = (props) => {
  const clsName = `form-control ${
    props.InputClassName ? props.InputClassName : ""
  }`;
  const InputBox = [
    "text",
    "hidden",
    "date",
    "time",
    "radio",
    "checkbox",
    "datetime-local",
    "autoComplete",
    "email",
    "number",
    "password",
  ];

  // const def = props.defaultValue ? props.defaultValue : '';
  const currentDate = new Date();
  const year = currentDate.getUTCFullYear();
  const month = String(currentDate.getUTCMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getUTCDate()).padStart(2, "0");

  const formattedDateTime = `${year}-${month}-${day}T00:00`;
  const formattedDate = `${year}-${month}-${day}`;

  const pickerElements = ["date", "time", "datetime-local"];
  const usePickerWrap =
    props.pickerIcon && pickerElements.includes(props.element);
  const pickerModifier =
    props.element === "datetime-local" ? "datetime" : props.element;
  const pickerInputClassName = [
    clsName,
    usePickerWrap ? `event-create-input--${pickerModifier}` : "",
  ]
    .filter(Boolean)
    .join(" ");

  const renderPickerInput = () => (
    <input
      type={props.element}
      id={props.Id}
      autoComplete="off"
      className={pickerInputClassName}
      defaultValue={props.defValue}
      checked={props.checked}
      placeholder={props.placeholder}
      style={props.style}
      {...props.Register(
        props.FieldName,
        FormValidation(props.FieldName, props.Label, props.ValidationArr)
      )}
      {...(props.clickHandler && { onChange: props.clickHandler })}
      {...(props.element === "datetime-local" && {
        min: formattedDateTime,
      })}
      {...(props.element === "number" && {
        min: 0,
      })}
      {...(props.element === "date" &&
      props.filter !== "true" &&
      props.FieldName != "dob"
        ? { min: formattedDate }
        : props.element === "date"
        ? { max: formattedDate }
        : {})}
      {...(props.min && { min: props.min })}
      {...(props.max && { max: props.max })}
      {...(props.disabled && { disabled: props.disabled })}
      {...(props.handleFocus && { onFocus: props.handleFocus })}
      {...(props.ref && { ref: props.ref })}
    />
  );

  let InputHtml = (
    <div
      className={`form-group ${
        props.CustomFormGroupCls ? props.CustomFormGroupCls : ""
      }`}
    >
      {props.Label && !props.LabelPosition && (
        <>
          <div style={{ display: "flex" }}>
            <label className={props.LabelCls} htmlFor={props.Id}>
              {props.Label}
              {props.ValidationArr && "*"}
            </label>
            {props.isIcon && (
              <i
                onClick={() => setShow(true)}
                style={{
                  marginLeft: "5px",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
                className="las la-question-circle"
              ></i>
            )}
          </div>
        </>
      )}

      {props.element === "radio" && props.selectDay && (
        <>
          <input
            type={props.element}
            id={props.Id}
            defaultValue={props.defValue}
            checked={props.checked}
            placeholder={props.placeholder}
            //  {...props.Register(
            //   props.FieldName,
            //   FormValidation(props.FieldName, props.Label, props.ValidationArr)
            // )}
            {...(props.clickHandler && { onChange: props.clickHandler })}
            {...(props.min && { min: props.min })}
            {...(props.max && { max: props.max })}
            min={props.min || 0}
            // {...(props.checked && { checked: props.checked })}
            {...(props.disabled && { disabled: props.disabled })}
            {...(props.handleFocus && { onFocus: props.handleFocus })}
            {...(props.ref && { ref: props.ref })}
          />
        </>
      )}

      {InputBox.includes(props.element) && !props.selectDay && (
        <>
          {usePickerWrap ? (
            <div className="event-create-input-icon-wrap">
              {renderPickerInput()}
              {props.element === "time" && (
                <i
                  className="bi bi-clock event-create-time-icon"
                  aria-hidden="true"
                />
              )}
              {props.element === "date" && (
                <i
                  className="bi bi-calendar3 event-create-date-icon"
                  aria-hidden="true"
                />
              )}
              {props.element === "datetime-local" && (
                <i
                  className="bi bi-calendar3 event-create-datetime-icon"
                  aria-hidden="true"
                />
              )}
            </div>
          ) : (
            <input
              type={props.element}
              id={props.Id}
              autoComplete="off"
              className={clsName}
              defaultValue={props.defValue}
              checked={props.checked}
              placeholder={props.placeholder}
              style={props.style}
              {...props.Register(
                props.FieldName,
                FormValidation(props.FieldName, props.Label, props.ValidationArr)
              )}
              {...(props.clickHandler && { onChange: props.clickHandler })}
              {...(props.element === "datetime-local" && {
                min: formattedDateTime,
              })}
              {...(props.element === "number" && {
                min: 0,
              })}
              {...(props.element === "date" &&
              props.filter !== "true" &&
              props.FieldName != "dob"
                ? { min: formattedDate }
                : props.element === "date"
                ? { max: formattedDate }
                : {})}
              {...(props.min && { min: props.min })}
              {...(props.max && { max: props.max })}
              {...(props.disabled && { disabled: props.disabled })}
              {...(props.handleFocus && { onFocus: props.handleFocus })}
              {...(props.ref && { ref: props.ref })}
            />
          )}
          {props.customError && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {props.customError}
            </span>
          )}
        </>
      )}

      {props.element == "textarea" && (
        <textarea
          {...(props.Id && { id: props.Id })}
          {...(props.rows && { rows: props.rows })}
          className={clsName}
          placeholder={props.placeholder}
          {...props.Register(
            props.FieldName,
            FormValidation(props.FieldName, props.Label, props.ValidationArr)
          )}
          {...(props.clickHandler && { onChange: props.clickHandler })}
        ></textarea>
      )}

      {props.element == "select" && (
        <select
          multiple={props.isMultipleSelect}
          defaultValue={props.defValue}
          value={props.defValue}
          className={clsName}
          {...(props.showInputValue && { value: props.defValue })}
          placeholder={props.placeholder}
          {...props.Register(
            props.FieldName,
            FormValidation(props.FieldName, props.Label, props.ValidationArr)
          )}
          {...(props.clickHandler && { onChange: props.clickHandler })}
        >
          {!props.isOptional && <option value="">Please select</option>}
          {Array.isArray(props.options) &&
            props.options.map((option, Index) => {
              return (
                <option key={Index} value={option[props.optionValue]}>
                  {option[props.optionLabel]}
                </option>
              );
            })}
        </select>
      )}

      {props.element == "button" && (
        <button
          {...(props.clickHandler && { onClick: props.clickHandler })}
          type={props.ButtonType ? props.ButtonType : "button"}
          className={`btn ${
            props.ButtonClass ? props.ButtonClass : "btn-light"
          }`}
          disabled={props?.isLoading}
        >
          {props.ITagClass && <i className={`fas ${props.ITagClass}`}></i>}{" "}
          {props.ButtonText}
        </button>
      )}

      {props.Label && props.LabelPosition == "bottom" && (
        <label className={props.LabelCls} htmlFor={props.Id}>
          {props.Label}
        </label>
      )}

      {props.LabelHtml && props.LabelPosition == "bottom" && (
        <label
          className={props.LabelCls}
          htmlFor={props.Id}
          {...(props.LabelHtml && {
            dangerouslySetInnerHTML: { __html: props.LabelHtml },
          })}
        ></label>
      )}

      {props.Errors[props.FieldName] && (
        <p className="error-text text-danger">
          {props.Errors[props.FieldName].message}
        </p>
      )}
    </div>
  );

  const [show, setShow] = useState(false);
  return (
    <>
      {!props.WrapperClass && InputHtml}
      {props.WrapperClass && (
        <div className={props.WrapperClass}>{InputHtml}</div>
      )}

      <VideoInstruction show={show} onHide={() => setShow(false)} />
    </>
  );
};
export default Input;
